const s = {
  name: "Location",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M29.2,12.8l-1.9-1.9L9,18.3v2.5l8.2,2l2,8.2h2.5L29.2,12.8z M18.8,21.2l-7.1-1.8l15.1-6.2l0.1,0.1l-6.2,15.1
			L18.8,21.2z"/>
		<path class="st0" d="M20,0C9,0,0,9,0,20s9,20,20,20c11,0,20-9,20-20S31,0,20,0z M2,20c0-9.9,8.1-18,18-18s18,8.1,18,18
			s-8.1,18-18,18S2,29.9,2,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Location
};
